
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
//services
import { TabService, AppCodes } from './tab.service';
import { ActionIconService } from '../ui-component/action-icon/action-icon.service';
import { UserSessionService } from '../../app-user-session.service';
import { ControlsParams } from '../../common/controls/controls-params';
@Component({
  selector: 'tab-ctrl',
  templateUrl: 'tab.component.html',
  styleUrls: ['tab.component.css']
})
export class TabComponent implements OnInit {
  @Output() clicked: EventEmitter<AppCodes>;
  @Input() paramsObject: ControlsParams;
  @Input() defaultTab: number;
  @Input() prefixLabel: string = '';
  @Input() parentUIKey: string;
  @Input() isSetUIState: boolean = true;
  @Input() tabActivationCheck: Function;
  @Input() appCodes: AppCodes[] = [];
  tabs: AppCodes[] = [];
  selectedTab: number;
  @Input()
  set forceTab(v: number) {
    this.selectedTab = v;
  }


  constructor(
    private _tabService: TabService,
    private _AIS: ActionIconService,
    private _USS: UserSessionService,
    public translate: TranslateService
  ) {
    this.clicked = new EventEmitter<AppCodes>();
  }
  ngOnInit() {
    if (this.paramsObject) {
      this._getControls(this.paramsObject);
    } else if (this.appCodes.length > 0) {
      this._getControls2();
    }
  }
  //par.linkId, par.appCodeGroup, par.required, par.appComponentName, par.category)
  _getControls(par: ControlsParams) {
    this._tabService
      .getControls(par.linkId, par.appCodeGroup, par.required, par.appComponentName, par.category)
      .subscribe(ctrl => {
        this.tabs = ctrl.data;
        this.setDefaultTab();
        if (this.tabs) {//abdo16/7/2022
          let selectTab = ctrl.data1[0].serial
          this._USS.setSessionKey('SelectedTab', selectTab); 
        }
      }, error => console.log(error),
        () => null);
  }
  _getControls2() {
    const _data = this._AIS.getCachedAppCodes('tabs', this.appCodes);
    if (_data.length > 0) {
      this.handeldbData(_data);
      this.setDefaultTab();
      return;
    }
    this._AIS
      .getControls(this.appCodes.toString())
      .subscribe(apps => {
        this._AIS.cachAppCodes('tabs', this.appCodes, apps['data']);
        this.handeldbData(apps.data);
        this.setDefaultTab();
      }
      );
  }
  handeldbData(apps: any) {
    this.tabs = []
    if (apps) {
      apps.forEach(item => {
        if (item.visible != 0) {
          this.tabs.push(item);
        }
      });
    }
  }
  setDefaultTab() {
    if (this.defaultTab == null)
      this.selectedTab = this.tabs[0].serial;
    else
      this.selectedTab = this.defaultTab;

    if (this.tabs && this.selectedTab == this.tabs[0].serial)
      this.setUIState(this.tabs[0]);
  };
  //abdo16/7/2022
  getDefaultTab() {
    return this.selectedTab
  }

  setDisable(code: number) {
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].serial == code) {
        this.tabs[i].disabled = true;
      }
    }
  }

  gotoTabOfAppcode(e: number) {
    let indx = this.tabs.findIndex(c => c['serial'] == e);
    if (indx >= 0 && this.tabs[indx])
      this.tabClicked(this.tabs[indx]);
  }

  tabClicked(ctrl: AppCodes) {
    if (!ctrl.disabled) {
      if (this.tabActivationCheck) {
        let checkResult = this.tabActivationCheck.call(this, ctrl);
        if (checkResult == -1) {
          return false;
        }
      }
      this.selectedTab = ctrl.serial;
      if (this.isSetUIState) {
        this.setUIState(ctrl);
      }
      this.clicked.emit(ctrl);
    }
  }
  setUIState(e: any) {
    this._USS.setUIState(e, this.parentUIKey);
  }
}
